import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { AppState } from '~/store/app.store';
import {
  activeBoundaryTerritoryGroupsSelector,
  boundaryTerritoryGroupsSelector,
  BTGsGroupedByBoundaryGroupSelector,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const boundaryToolBTGsSelector = createStateSelector([
  boundaryTerritoryGroupsSelector,
], (boundaryTerritoryGroups: readonly BoundaryTerritoryGroup[]): readonly BoundaryTerritoryGroup[] => {
  return boundaryTerritoryGroups.filter(btg => !isDataLayersArtificialBoundaryTerritoryGroup(btg));
});
export const useBoundaryToolBTGsSelector = () => useSelector(boundaryToolBTGsSelector);

export const useBoundaryToolBTGsGroupedByBoundaryGroupSelector = () => useSelector(BTGsGroupedByBoundaryGroupSelector).boundaryTool;

export const boundaryToolActiveBTGsSelector = (state: AppState) => activeBoundaryTerritoryGroupsSelector(state, false);
export const useBoundaryToolActiveBTGsSelector = () => useSelector(boundaryToolActiveBTGsSelector);
